import sendData from '../../../../utils/sendData'

export const success = () => {
  sendData('account.register.step1.page_load.success')
}
